import React from 'react';
import cn from 'classnames';
import {StandardProps} from '.';

export type CardProps = StandardProps;

export const Card: React.FC<CardProps> = ({className, ...restProps}) => {
  return <div className={cn('card', className)} {...restProps} />;
};

export default Card;
